import { TimeInput, type TimeInputProps } from '@mantine/dates';

const TimeInputDefaults = TimeInput.extend({
  defaultProps: {
    radius: 'sm',
    pointer: true,
  },
});

export { TimeInput, TimeInputDefaults };
export type { TimeInputProps };
